import { XMarkIcon } from '@heroicons/react/24/solid';
import Spinner from '../Spinner';

interface ReactivateCaseModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    isSubmitting?: boolean;
}

function ReactivateCaseModal({
    isOpen,
    onClose,
    onSubmit,
    isSubmitting = false
}: ReactivateCaseModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div
                className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4">
                    <h2 className="text-xl font-bold text-gray-800">Reactivate this case</h2>
                    <button
                        onClick={onClose}
                        disabled={isSubmitting}
                        className={`${isSubmitting ? 'text-gray-300 cursor-not-allowed' : 'text-gray-400 hover:text-gray-800'}`}
                        aria-label="Close"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>

                {/* Content */}
                <div className="px-6 pb-4 flex flex-col gap-3 py-4">
                    <p className="text-sm text-gray-600">
                        Reactivating this case initiates the <strong>redesign</strong> process.
                    </p>
                    <p className="text-sm text-gray-600">
                        Depending on how long the case has been closed, the new design may require
                        more recent patient records.
                    </p>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200">
                    <button
                        onClick={onClose}
                        disabled={isSubmitting}
                        className={`px-4 py-2 text-sm font-semibold rounded-lg border ${
                            isSubmitting
                                ? 'text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed'
                                : 'text-gray-800 bg-white border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSubmit}
                        disabled={isSubmitting}
                        className={`px-6 py-2.5 text-sm font-bold rounded-lg flex items-center gap-2 ${
                            isSubmitting
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-gray-800 text-white hover:bg-gray-700'
                        }`}
                    >
                        {isSubmitting && <Spinner />}
                        Yes, reactivate case
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ReactivateCaseModal;
